import { FC, useState } from "react";
import PageContainer from "../../components/PageContainer";
import { Id } from "src/utils/types";
import { Collaborator, CollaboratorServicesSummary, getCollaboratorServices, getCollaboratorServicesSummary } from "src/apis/company";
import { Box } from "@mui/material";
import CompanySelect from "src/pages/components/CompanySelect";
import FilterButtons from "src/pages/components/SearchAndResetButtons";
import CollaboratorSelect from "src/pages/components/CollaboratorSelect";
import { Service } from "src/apis/services";
import StartAndEndDateFilters from "src/pages/components/StartAndEndDateFilters";
import { getFirstDayOfMonth, getLastDayOfMonth } from "src/utils/date";
import SummaryFab from "src/pages/components/SummaryFab";
import ServicesByColaboratorSummaryTable from "./components/ServicesByColaboratorSummaryTable";
import ServicesTable from "src/pages/components/ServicesTable";

const ServicesByColaborator: FC = (): JSX.Element => {
  const [error, setError] = useState<string>('')
  const [startDate, setStartDate] = useState(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState(getLastDayOfMonth());
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [companyId, setCompanyId] = useState<Id>('')
  const [collaboratorId, setCollaboratorId] = useState<Id>('')
  const [services, setServices] = useState<Service[]>([]);
  const [summary, setSummary] = useState<CollaboratorServicesSummary|null>(null);

  const fetchServices = async (): Promise<void> => {
    if (!companyId || !collaboratorId) return;

    setIsLoading(true);

    try {
      const resServices = await getCollaboratorServices(
        companyId,
        collaboratorId,
        startDate,
        endDate);

      setServices(resServices);

      if (resServices.length > 0) {
        const resSummary = await getCollaboratorServicesSummary(
          companyId,
          collaboratorId,
          startDate,
          endDate);
        setSummary(resSummary);
      }

      setError('')
    } catch (err: any) {
      setError(err?.message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <PageContainer title="Atendimentos por colaborador" error={error}>
      {Boolean(summary) && (
        <SummaryFab>
          <ServicesByColaboratorSummaryTable startDate={startDate} endDate={endDate} summary={summary} />
        </SummaryFab>
      )}

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        }}
      >
        <CompanySelect
          isFilter
          companyId={companyId}
          setCompanyId={setCompanyId}
          setError={setError}
        />
        <CollaboratorSelect
          isFilter
          companyId={companyId}
          collaboratorId={collaboratorId}
          setCollaborator={(collaborator: Collaborator) => {
            setCollaboratorId(collaborator?.id_colaborador);
          }}
          setError={setError}
        />
        <StartAndEndDateFilters
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
        <FilterButtons
          isLoading={isLoading}
          isDisabled={!companyId || !collaboratorId}
          search={() => {
            fetchServices();
          }}
          resetState={() => {
            setCollaboratorId('');
            setCompanyId('');
            setServices([]);
            setSummary(null);
          }}
        />
      </Box>

      <ServicesTable
        services={services}
        setError={setError}
      />
    </PageContainer>
  )
}

export default ServicesByColaborator
